const journal = {
	name: 'Buchungen',
	fields: {
		primanota: 'Primanota',
		booking_date: 'Buchungsdatum',
		contra_account_id: 'Gegenkonto',
		debit: 'Soll',
		credit: 'Haben',
		opening_balance: 'Vortrag',
		booking_text: 'Buchungstext',
		comments_count: 'Kommentare',
		document_container_id: 'Beleg',
		review_state: 'Geprüft',
	},
}

export default journal
